export function setVehicleDb(vehicles, prevVehicleDb) {
    return function(dispatch) {
        var vehicleDb = prevVehicleDb;
        for (var i = 0; i < vehicles.length; i++) {
            if (! (vehicles[i].V_ID in vehicleDb)) {
                vehicleDb[vehicles[i].V_ID] = vehicles[i]
            } else {
                var vehicle_keys = Object.keys(vehicles[i])
                for (var k = 0; k < vehicle_keys.length; k++) {
                    vehicleDb[vehicles[i].V_ID][vehicle_keys[k]] = vehicles[i][vehicle_keys[k]]
                }
            }
        }

        dispatch({type: "SET_VEHICLE_DB", payload: {
            vehicle_db: vehicleDb, vehicles: vehicles
        }})
    }
}
export function setEnduserData(response) {
    return function(dispatch) {
        dispatch({type: "SET_EU_DATA", payload: {
            outstanding_bookings: response?.data.outstanding_bookings,
            vehicles: response?.data.vehicles,
            dashboard_bookings: response?.data.bookings,
            filters: response?.data.filters
        }})
    }
}

export function setSidebar(response) {
    return function(dispatch) {
        dispatch({type: "SET_SIDEBAR", payload: response?.data})
    }
}

//Globally allow a booking to come from the side of the screen to view, edit, or cancel
export function openPullout(booking) {
    return function(dispatch) {
        dispatch({type: "SET_BOOKING", payload: booking})
    }
}

export function closePullout() {
    return function(dispatch) {
        dispatch({type: "CLOSE_PULLOUT"})
    }
}

export function setList(type, list) {
    return function(dispatch) {
        dispatch({type: type, payload: list})
    }
}

export function setListEndUser(type, list) {
    return function(dispatch) {
        dispatch({type: type, payload: list})
    }
}